<template>
	<v-app :style="$vuetify.theme.dark ? '' : 'background-color: #f7f7f7'">
		<v-app-bar app clipped-right absolute class="head_bg mt-3 mx-3" elevation="0" rounded :class="$vuetify.theme.dark ? '' : 'white'" style="z-index: 4">
			<v-toolbar-title class="font-weight-medium vtk-cursor-pointer" @click="toHome">{{ $vtk.env.VUE_APP_HEAD }}</v-toolbar-title>
			<v-menu offset-y nudge-width="200" nudge-bottom="18">
				<template v-slot:activator="{ on, attrs }">
					<v-btn class="rounded-pill primary--text ml-3" v-bind="attrs" v-on="on" text large> {{ user.uniName }} <v-icon>mdi-menu-down</v-icon></v-btn>
				</template>
				<v-list dense>
					<v-subheader>切换企业</v-subheader>
					<v-list-item-group color="primary">
						<v-list-item v-for="(item, index) in user.depts" :key="index" @click="depts(item)">
							<v-list-item-content>
								<v-list-item-title> {{ item.uniName }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-menu>
			<v-spacer />
			<v-btn v-show="user && user.uniCode && user.uniCode == '91330108MA2H3MND51'" to="/uams-dept-roles-page" class="ml-4 px-0" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
				<v-icon color="blue">mdi-cog-outline</v-icon>
			</v-btn>
			<v-btn class="ml-4 px-0" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
				<v-icon color="blue">mdi-bell-outline</v-icon>
			</v-btn>
			<v-btn class="ml-4 px-0 g-d-sm-none" @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
				<v-icon color="blue">mdi-theme-light-dark</v-icon>
			</v-btn>
			<v-btn class="ml-4 px-0 g-d-sm-none" @click="exit" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" elevation="0" small style="min-height: 40px; min-width: 40px">
				<v-icon color="blue">mdi-power</v-icon>
			</v-btn>
		</v-app-bar>

		<w-navi style="z-index: 5" />
		<w-sets style="z-index: 5" />

		<v-main class="divder pt-0 px-0 g-pb-sm-12" :style="`background:url(${require('@/assets/background.png')}) fixed`" style="margin-left: 88px; margin-top: 76px">
			<w-tabs style="position: sticky; top: 64px; z-index: 3" />
			<keep-alive>
				<router-view v-if="userShow" />
			</keep-alive>
		</v-main>
		<wtk-message><!--弹出消息区域--></wtk-message>
	</v-app>
</template>

<script>
import wNavi from "./_navi-left";
import wTabs from "./_tabs";
import wSets from "./_sets";
import Message from "@/components/message";
import Storage from "@/commons/storage";
import Request from "@/commons/request";
export default {
	name: "AdminMain",
	components: { wNavi, wTabs, wSets },
	data: () => ({
		user: {},
		userShow: false,
	}),
	mounted() {
		//1.1 解析用户信息并缓存
		let stoken = Storage.get("_wit_acis_token");
		// let users = Storage.get("_wit_acis_users");
		let jwt = {};
		if (stoken) {
			let token = stoken?.replace(/-/g, "+")?.replace(/_/g, "/");
			jwt = JSON.parse(decodeURIComponent(escape(window.atob(token?.split(".")[1]))));
		}
		// this.user = users || this.user;
		//1.2 获取缓存用户信息
		this.detail(jwt.useruuid);
	},
	methods: {
		// 提出登录
		exit() {
			Message.confirm({ title: "确认退出", text: "确认清除数据并退出吗？" }, (res) => {
				if (res) {
					Request.postForm("/unia/admin/logix").then((res) => {
						if (res.meta.success) {
							Storage.clear(); //清除所有缓存
							window.document.location.href = this.$vtk.env.VUE_APP_LOGIX;
						}
					});
				}
			});
		},
		// 返回首页
		toHome() {
			!location.href.includes("/home") && this.$router.push({ path: "/home" });
		},
		// 切换企业
		depts(item) {
			if (this.user.did != item.did) {
				Message.loading.show();
				Request.postJson("/unia/admin/login/dept", { did: item.did, stoken: Storage.get("_wit_acis_token") }).then((res) => {
					Message.loading.hide();
					if (res.meta.success) {
						Storage.clear();
						Storage.set("_wit_acis_token", res.data.token); //只用存储token
						location.reload();
					} else {
						Message.toast(res.meta.message, { color: "error" });
					}
				});
			}
		},
		//解析用户信息
		detail(uid) {
			Request.postForm("/view/users/view", { uid: uid }).then((res) => {
				if (res.meta.success) {
					this.user = res.data;
					Storage.set("_wit_acis_users", res.data);
					this.userShow = true;
				} else {
					Message.confirm("对不起，您的登录信息过期无效请重新登录！", () => {
						Storage.clear(); //清除所有缓存
						window.location.href = "#/login";
					});
				}
			});
		},
	},
};
</script>
<style>
.head_bg {
	background-image: url(../../assets/img/head_bg.png);
	background-size: cover;
}
</style>
